import './TwoColumnLayout.css';

export const TwoColumnLayout = ({ leftColumn, rightColumn, className = '' }) => {
  return (
    <div className={`two-column-layout ${className}`.trim()}>
      <div className="two-column-layout__left">
        {leftColumn}
      </div>
      <div className="two-column-layout__right">
        {rightColumn}
      </div>
    </div>
  );
};

